import { render, staticRenderFns } from "./addAffiliateProduct.vue?vue&type=template&id=02e7476e&scoped=true"
import script from "./addAffiliateProduct.vue?vue&type=script&lang=js"
export * from "./addAffiliateProduct.vue?vue&type=script&lang=js"
import style0 from "./addAffiliateProduct.vue?vue&type=style&index=0&id=02e7476e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e7476e",
  null
  
)

export default component.exports